<template>
    <ul>
        <li v-for="(item, index) in list" :key="index" v-show="item.type !== 6" @click="detailFeedback(item)">
            <div class="flex">
                <el-popover placement="left" trigger="hover">
                    <img slot="reference" v-if="item.type != 7 && item.type != 9" src="../../static/IM/file.png"
                        class="details-img" alt="" />
                    <taskDetails v-if="item.caseMgrSchemeItemVO && item.caseMgrSchemeItemVO.type"
                        :form="item.caseMgrSchemeItemVO" />
                </el-popover>
                <div :class="item.type == 7 ? 'feek' : ''">
                    <div class="top">
                        <div class="task-name">
                            {{ item.type | getTypeName }}
                        </div>
                        <div class="task-cen">-</div>
                        <div class="task-content">{{ item.content }}</div>
                    </div>
                    <div class="bot" v-if="item.patientSchemeName && item.doctorTeamName">
                        <span>{{ item.patientSchemeName }} - {{ item.doctorTeamName }}</span>
                    </div>
                    <!-- 专属复诊计划 -->
                    <div class="bot" v-if="item.type == 5">
                        <span>{{ item.advantage }}</span>
                    </div>
                </div>
            </div>
            <div v-if="item.type == 9">
                <el-button size="mini" type="text" @click.stop="editFeedback(item)">编辑</el-button>
                <el-button size="mini" type="text" @click.stop="detailFeedback(item)">预览</el-button>
                <el-button size="mini" type="text" @click.stop="sendFeedback(item)">发送</el-button>
            </div>
            <template v-else>
                <template v-if="isFinish">
                    <div v-if="item.status == 1" class="task-over">
                        <span>标记成功</span>
                    </div>
                </template>
                <template v-else>
                    <div v-if="item.status == 2 && item.type !== 1 && item.type !== 7">
                        <el-button size="mini" type="text" @click.stop="overTask(item)">标记完成</el-button>
                    </div>
                    <!-- item.status == 1 为开始 -->
                    <div v-if="item.status == 2 && item.type === 1">
                        <el-button size="mini" type="text" @click.stop="importKeyClick(item)">开始</el-button>
                    </div>
                    <!-- 及时反馈按钮 -->
                    <div v-if="item.status == 2 && item.type === 7">
                        <el-button size="mini" type="text" @click.stop="editFeedback(item)">编辑</el-button>
                        <el-button size="mini" type="text" @click.stop="sendFeedback(item)">发送</el-button>
                    </div>
                </template>
            </template>
        </li>
        <feedbackPreviewDialog ref="feedbackPreviewDialogRef"></feedbackPreviewDialog>
    </ul>
</template>

<script>
import {
    apiPutTaskOver,
    sendFeedbackReport,
} from "@/views/newPatientmanage/api/treatmentPlan.js";
import taskDetails from "./component/taskDetails.vue";
import feedbackPreviewDialog from '@/views/ToolMaintenance/component/feedbackPreviewDialog'

export default {
    props: {
        list: {
            type: Array,
            default: [],
        },
        patientId: {
            type: String,
        },
        isFinish: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        taskDetails,
        feedbackPreviewDialog,
    },
    data() {
        return {};
    },
    mounted() { },
    filters: {
        getTypeName(type) {
            if (type == 1 || type == 8) {
                return '提醒任务'
            }
            if (type == 2) {
                return '问诊说明'
            }
            if (type == 3) {
                return '随访说明'
            }
            if (type == 4) {
                return '评估说明'
            }
            if (type == 5) {
                return '复诊计划'
            }
            if (type == 6) {
                return '重点指标'
            }
            if (type == 7) {
                return '及时反馈'
            }
            if (type == 9) {
                return '模版反馈'
            }
        },
    },
    methods: {
        detailFeedback(item) {
            if (item.type == 9) {
                this.$refs.feedbackPreviewDialogRef.showDialog(item.refId)
                return
            }
            if (this.isFinish && item.type === 7) {
                this.handleFeedbackVisible({
                    addFeedbackTitle: '及时反馈',
                    addFeedbackStatus: 'detail',
                    addFeedbackVisible: true,
                    patientFeedbackTask: item,
                })
            }
        },
        //标记完成按钮
        overTask(item) {
            apiPutTaskOver({
                status: '1',
                id: item.id
            }).then(res => {
                if (res.code == 0) {
                    this.$message.success('标记成功')
                    item.status = 1
                    // 调用列表接口
                    this.$emit('getPatientRightData', 7)
                } else {
                    this.$message.error(res.message)
                }
            });
        },
        // 点击展示重点标识弹框--状态为开始状态时才可加这个方法在开始的按钮上
        importKeyClick(item) {
            this.handleFeedbackVisible({
                addFeedbackTitle: '添加反馈',
                addFeedbackStatus: 'begin',
                addFeedbackVisible: true,
                patientFeedbackTask: {
                    patientId: this.patientId,
                    wholeCourseId: item.wholeCourseId,
                    patientSchemeItemId: item.patientSchemeItemId,
                    refId: '',
                    caseMsgId: item.id,
                },
            })
        },
        editFeedback(item) {
            this.handleFeedbackVisible({
                addFeedbackTitle: '编辑反馈',
                addFeedbackStatus: 'edit',
                addFeedbackVisible: true,
                patientFeedbackTask: item,
            })
        },
        async sendFeedback(item) {
            var channel = ''
            if (item.type == 9) {
                channel = 'IM'
            }
            let { code } = await sendFeedbackReport(item.refId, channel)
            if (code === 0) {
                this.$message.success('发送成功')
                this.$emit('getPatientRightData', 7)
            }
        },
        handleFeedbackVisible(map) {
            this.$emit('handleFeedbackVisible', map)
        }
    }
};
</script>

<style lang="less">
@import "./taskReminder.less";
</style>

<style scoped lang="less">
.flex {
    display: flex;
}

.details-img {
    width: 32px;
    height: 32px;
    cursor: pointer;
    margin-right: 15px;
}

.feek {
    margin-left: 47px;
}
</style>
